import gsap, {Linear} from 'gsap';
import {debounce} from 'throttle-debounce';

import {IS_TOUCH} from '../helpers/consts';

const CLONE_WORD_COUNT = 5;
const MAX_WIDTH = 10000;

export const initLines = (containers) => {

	containers.forEach((container) => {
		const BASE_TIME = container.getAttribute('data-base-time');

		const startLine = container.querySelector('.js-line');
		const startWordsGroup = container.querySelector('.js-words-group-wrapper');


		for (let i = 0; i < CLONE_WORD_COUNT; i++) {
			const wordClone = startWordsGroup.cloneNode(true);
			startLine.appendChild(wordClone);
		}

		let lineWidth = 0;
		let time = 0;
		const lineClone = startLine.cloneNode(true);
		const dataDirection = container.getAttribute('data-direction');
		const direction = dataDirection ? dataDirection : 'left';
		let timeline = null;
		let clonedLine = null;

		const getLineTime = (elWidth) => {
			const windowW = document.body.offsetWidth;
			const sizeCoef = MAX_WIDTH / (MAX_WIDTH - windowW);
			const length = (elWidth / 1000);
			const final = (BASE_TIME / sizeCoef) * length;
			return final;
		};

		const pauseLineAnim = () => {
			if (timeline) timeline.pause();
		};

		const playLineAnim = () => {
			if(timeline) timeline.play();
		};

		const initTimeline = () => {
			timeline = new gsap.timeline({repeat: -1, paused: true});
			const animateValue1 = direction === 'left' ? -lineWidth : lineWidth;
			const animateValue2 = direction === 'left' ? lineWidth : -lineWidth;

			timeline
				.fromTo(startLine, {rotation:0.01, x:0}, {force3D:true, x: animateValue1, ease: Linear.easeNone, duration: time}, 0)
				.fromTo(clonedLine, {rotation:0.01, x:animateValue2}, {force3D:true, x:0, ease: Linear.easeNone, duration: time}, 0)
				.set(startLine, {force3D:true, rotation:0.01, x: animateValue2})
				.to(clonedLine, {force3D:true, rotation:0.01, x: animateValue1, ease: Linear.easeNone, duration: time}, time)
				.to(startLine, {force3D:true, rotation:0.01, x: 0, ease: Linear.easeNone, duration: time}, time)
				.progress(1).progress(0)
				.play();

			if(!IS_TOUCH) {
				container.addEventListener('mouseenter', pauseLineAnim);
				container.addEventListener('mouseleave', playLineAnim);
			}

		};

		const destroyTimeline = () => {
			timeline.pause();
			timeline.kill();
			timeline = null;

			if(!IS_TOUCH) {
				container.removeEventListener('mouseenter', pauseLineAnim);
				container.removeEventListener('mouseleave', playLineAnim);
			}
		};

		const resize = () => {
			lineWidth = startWordsGroup.offsetWidth * (CLONE_WORD_COUNT + 1);
			time = getLineTime(lineWidth);

			if(timeline === null) {
				initTimeline();
			}
			else {
				destroyTimeline();
				initTimeline();
			}
		};

		lineClone.classList.add('cloned');
		container.appendChild(lineClone);

		clonedLine = container.querySelector('.js-line.cloned');

		resize();

		if (IS_TOUCH) {
			window.addEventListener('orientationchange', debounce(450, () => {
				resize();
			}));
		}
		else {
			window.addEventListener('resize', debounce(300, resize));
		}

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if(entry.isIntersecting) {
					playLineAnim();
				}
				else {
					pauseLineAnim();
				}
			});
		}, { threshold: 0 });
		observer.observe(container);

	});

};
export default () => {

	const lineContainer = document.querySelectorAll('.js-line-container');
	initLines(lineContainer);

};
